import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.dialogIsReady,
      "persistent": "",
      "max-width": "75%"
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.editObject === null || _vm.copyMode ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.formIsValid,
            "prepend-icon": "fa-save"
          },
          on: {
            "click": _vm.handleSave
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.save')) + "\n    ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.editObject === null || _vm.copyMode ? _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.title') : _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.titleView')) + "\n  ")];
      },
      proxy: true
    }])
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    staticClass: "ma-0",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.name'),
      "hide-details": "",
      "readonly": _vm.isReadonly && !_vm.copyMode,
      "clearable": !_vm.isReadonly
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('core-account-selector', {
    attrs: {
      "clearable": !_vm.isReadonly,
      "readonly": _vm.isReadonly && !_vm.copyMode,
      "hide-details": ""
    },
    model: {
      value: _vm.accountId,
      callback: function ($$v) {
        _vm.accountId = $$v;
      },
      expression: "accountId"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "data-cy": "export_parent_id",
      "disabled": !_vm.accountId,
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "tenantId": _vm.accountId,
      "loadFullDtwinData": false,
      "sameTenant": "",
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.parentId,
      callback: function ($$v) {
        _vm.parentId = $$v;
      },
      expression: "parentId"
    }
  }), _c(VCol)], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.title')) + "\n          ")]), _c(VExpansionPanelContent, [_c(VBtnToggle, {
    attrs: {
      "color": _vm.color,
      "mandatory": ""
    },
    model: {
      value: _vm.filterType,
      callback: function ($$v) {
        _vm.filterType = $$v;
      },
      expression: "filterType"
    }
  }, [!_vm.isReadonly || _vm.filterType === 'digitalTwin' || _vm.copyMode ? _c(VBtn, {
    attrs: {
      "value": "digitalTwin",
      "text": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.digitalTwins')) + "\n              ")]) : _vm._e(), !_vm.isReadonly || _vm.filterType === 'virtualDevice' || _vm.copyMode ? _c(VBtn, {
    attrs: {
      "value": "virtualDevice",
      "text": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.virtualDevices')) + "\n              ")]) : _vm._e()], 1), _vm.filterType === 'digitalTwin' ? _c('core-csv-export-search-digital-twins', {
    attrs: {
      "search": _vm.search,
      "readonly": _vm.isReadonly && !_vm.copyMode
    },
    on: {
      "updated": _vm.updateFilter
    }
  }) : _c('core-csv-export-search-virtual-devices', {
    attrs: {
      "readonly": _vm.isReadonly && !_vm.copyMode,
      "search": _vm.search,
      "accountId": _vm.accountId,
      "operator": _vm.searchOperator
    },
    on: {
      "updated": _vm.updateFilter
    }
  }), _vm._v("\n            " + _vm._s(_vm.searchTotalCountMessage) + "\n          ")], 1)], 1)], 1)], 1)], 1), _vm.showStructureSection ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.selectCsvStructure')) + "\n            ")]), _c(VExpansionPanelContent, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.selectCsvStructureDescription')) + "\n              "), _c(VSwitch, {
    staticClass: "switch-dense",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.clusterPacketDataPerRow'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "inset": ""
    },
    model: {
      value: _vm.csvOptions.clusterPerPacket,
      callback: function ($$v) {
        _vm.$set(_vm.csvOptions, "clusterPerPacket", $$v);
      },
      expression: "csvOptions.clusterPerPacket"
    }
  }), _vm.csvOptions.clusterPerPacket ? _c(VRow, [_c(VCol, [_c(VAutocomplete, {
    attrs: {
      "items": _vm.allDriversVariables,
      "item-text": item => `${item.title}${` (${item.count} ${_vm.$i18n_t('Common.of')} ${_vm.drivers.length} ${_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.deviceDrivers')})`}`,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "hide-details": "",
      "multiple": "",
      "return-object": "",
      "small-chips": ""
    },
    model: {
      value: _vm.selectedDriversVariables,
      callback: function ($$v) {
        _vm.selectedDriversVariables = $$v;
      },
      expression: "selectedDriversVariables"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)] : _vm._e(), !_vm.showStructureSection || !_vm.csvOptions.clusterPerPacket ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.stateIdentifiers.title')) + "\n            ")]), _c(VExpansionPanelContent, [_c(VAutocomplete, {
    attrs: {
      "search-input": _vm.stateIdSearchInput,
      "items": _vm.stateIdentifiers,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.stateIdentifiers.label'),
      "item-text": item => `${item.key}-${item.valueType}`,
      "item-value": item => `${item.key}-${item.valueType}`,
      "multiple": "",
      "chips": "",
      "hide-details": "",
      "disabled": _vm.stateIdentifiers.length === 0,
      "readonly": _vm.isReadonly && !_vm.copyMode,
      "clearable": !_vm.isReadonly
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.stateIdSearchInput = $event;
      },
      "update:search-input": function ($event) {
        _vm.stateIdSearchInput = $event;
      },
      "change": function ($event) {
        _vm.stateIdSearchInput = null;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VCheckbox, {
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "value": _vm.selectedStates.includes(`${item.key}-${item.valueType}`)
          }
        }), _vm._v("\n                  " + _vm._s(item.key) + " (" + _vm._s(item.valueType) + ") (" + _vm._s(item.statesCount) + "\n                  " + _vm._s(_vm.$i18n_t('Common.of')) + "\n                  " + _vm._s(_vm.searchTotalCount) + "\n                  " + _vm._s(_vm.$i18n_t(`BackgroundJobs.ScheduledExports.dialog.data.${_vm.filterType === 'digitalTwin' ? 'digitalTwins' : 'virtualDevices'}`)) + ")\n                ")];
      }
    }, {
      key: "selection",
      fn: function ({
        item
      }) {
        return [_c(VChip, [[_vm._v("\n                      " + _vm._s(item.key) + " (" + _vm._s(item.valueType) + ") (" + _vm._s(item.statesCount) + "\n                      " + _vm._s(_vm.$i18n_t('Common.of')) + "\n                      " + _vm._s(_vm.searchTotalCount) + "\n                      " + _vm._s(_vm.$i18n_t(`BackgroundJobs.ScheduledExports.dialog.data.${_vm.filterType === 'digitalTwin' ? 'digitalTwins' : 'virtualDevices'}`)) + ")\n                    ")]], 2)];
      }
    }], null, false, 550576882),
    model: {
      value: _vm.selectedStates,
      callback: function ($$v) {
        _vm.selectedStates = $$v;
      },
      expression: "selectedStates"
    }
  })], 1)], 1)], 1)], 1)], 1)] : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timezone.title')) + "\n          ")]), _c(VExpansionPanelContent, [_c('core-timezone-selector', {
    attrs: {
      "required": "",
      "clearable": !_vm.isReadonly,
      "readonly": _vm.isReadonly && !_vm.copyMode
    },
    model: {
      value: _vm.timezone,
      callback: function ($$v) {
        _vm.timezone = $$v;
      },
      expression: "timezone"
    }
  })], 1)], 1)], 1)], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.title')) + "\n          ")]), _c(VExpansionPanelContent, [_c('core-csv-export-frequency', {
    attrs: {
      "readonly": _vm.isReadonly && !_vm.copyMode
    },
    model: {
      value: _vm.frequency,
      callback: function ($$v) {
        _vm.frequency = $$v;
      },
      expression: "frequency"
    }
  })], 1)], 1)], 1)], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timeRange.title')) + "\n          ")]), _c(VExpansionPanelContent, [_c(VSelect, {
    attrs: {
      "items": _vm.timeRangeItems,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": _vm.isReadonly && !_vm.copyMode,
      "hide-details": ""
    },
    model: {
      value: _vm.timeRange,
      callback: function ($$v) {
        _vm.timeRange = $$v;
      },
      expression: "timeRange"
    }
  })], 1)], 1)], 1)], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.title')) + "\n          ")]), _c(VExpansionPanelContent, [_c(VSelect, {
    attrs: {
      "items": _vm.dataAggregationItems,
      "item-value": "key",
      "item-text": "text",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": _vm.isReadonly && !_vm.copyMode,
      "hide-details": ""
    },
    model: {
      value: _vm.selectedAggregationKey,
      callback: function ($$v) {
        _vm.selectedAggregationKey = $$v;
      },
      expression: "selectedAggregationKey"
    }
  })], 1)], 1)], 1)], 1)], 1), _c(VRow, [_c(VCol, [_c(VExpansionPanels, {
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.csvExportDestinationSettings')) + "\n          ")]), _c(VExpansionPanelContent, [_c(VRow, [_c(VCol, {
    staticClass: "pl-3 pr-0 d-flex",
    attrs: {
      "cols": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.forwardOptions,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "readonly": _vm.isReadonly && !_vm.copyMode
    },
    model: {
      value: _vm.selectedOption,
      callback: function ($$v) {
        _vm.selectedOption = $$v;
      },
      expression: "selectedOption"
    }
  })], 1)], 1), _vm.selectedOption === 'sendoutDownloadLink' ? _c('core-csv-export-email', {
    attrs: {
      "mailConnectors": _vm.mailConnectors,
      "readonly": _vm.isReadonly && !_vm.copyMode
    },
    model: {
      value: _vm.emailsData,
      callback: function ($$v) {
        _vm.emailsData = $$v;
      },
      expression: "emailsData"
    }
  }) : _vm._e(), _vm.selectedOption === 'forwardToThirdParty' ? _c('core-csv-export-forward-to-third-party', {
    attrs: {
      "outboundConnectors": _vm.outboundConnectors,
      "readonly": _vm.isReadonly && !_vm.copyMode
    },
    model: {
      value: _vm.thirdPartyData,
      callback: function ($$v) {
        _vm.thirdPartyData = $$v;
      },
      expression: "thirdPartyData"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _c(VRow, [_c(VCol, [_c(VExpansionPanels, {
    attrs: {
      "value": 1
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('BackgroundJobs.ScheduledExports.dialog.csvFormattingOptions.extendedCsvFormattingOptions')) + "\n          ")]), _c(VExpansionPanelContent, {
    attrs: {
      "eager": ""
    }
  }, [_c('core-csv-export-formatting-options', {
    attrs: {
      "filterType": _vm.filterType,
      "readonly": _vm.isReadonly && !_vm.copyMode,
      "customProperties": _vm.customProperties,
      "references": _vm.references,
      "driversCount": _vm.drivers.length,
      "selectedDriversVariables": _vm.selectedDriversVariables,
      "devicesCount": _vm.searchTotalCount
    },
    model: {
      value: _vm.csvOptions,
      callback: function ($$v) {
        _vm.csvOptions = $$v;
      },
      expression: "csvOptions"
    }
  })], 1)], 1)], 1)], 1)], 1)], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };